import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Carousel } from 'react-responsive-carousel'
import { FaAngleLeft } from '@react-icons/all-files/fa/FaAngleLeft'
import { FaAngleRight } from '@react-icons/all-files/fa/FaAngleRight'
import { StyleSheet, css } from 'aphrodite';

const styles = StyleSheet.create({
    controls: {
        fontSize: '30px',
        height: '100%',
        textAlign: 'center',
        cursor: 'pointer'
    }
});

class Slider extends Component {
    constructor(props) {
        super(props);

        this.state = {
            index: 1
        }
    }

    next = () => {
        this.setState({
            index: this.state.index + 1
        })
    }

    prev = () => {
        this.setState({
            index: this.state.index - 1
        })
    }

    detectOnChange = (index) => {

        this.setState({
            index: index
        })

    }

    render() {
        return (
            <Container>
                <Row>
                    <Col className="d-none d-sm-block" md={1}><FaAngleLeft onClick={this.prev} className={css(styles.controls)} /></Col>
                    <Col xs={12} md={10} className="p-0 shadow">
                        <Carousel onChange={this.detectOnChange} selectedItem={this.state.index} axis="horizontal" infiniteLoop autoPlay showThumbs={false} showStatus={false} showIndicators={false} showArrows={false} >
                            {this.props.children}
                        </Carousel>
                    </Col>
                    <Col className="d-none d-sm-block" md={1}><FaAngleRight onClick={this.next} className={css(styles.controls) + " float-right"} /></Col>
                </Row>
            </Container>
        );
    }
}

export default Slider;